import "core-js/modules/es.function.name.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NoData from '@/components/NoData/NoData';
import DynamicUsers from '@/components/System/role/DynamicUsers';
import RegularUsers from '@/components/System/role/RegularUsers';
import windowHeightMixin from '@/mixins/windowHeightMixin';
export default {
  components: {
    NoData: NoData,
    DynamicUsers: DynamicUsers,
    RegularUsers: RegularUsers
  },
  mixins: [windowHeightMixin],
  data: function data() {
    return {
      roleId: null,
      systemId: null,
      activeTabName: 'BASIC',
      showUserTab: false,
      tableLoading: false,
      // 角色基本信息数据
      basicInfoFormData: {
        roleName: '',
        systemId: '',
        systemName: '',
        roleId: '',
        roleStatus: 'VALID',
        roleType: 'BUSINESS',
        roleDescription: '',
        canSetManageOrg: 1,
        canSetBizLine: 1,
        autoComputeArea: 1,
        dependOrg: '',
        id: '',
        roleOrd: '',
        rolePermissionRefDtoS: []
      },
      // 角色基本信息验证规则
      basicRules: {
        roleName: [{
          required: true,
          message: '您还没有填写角色名称，请填写',
          trigger: 'blur'
        }],
        systemId: [{
          required: true,
          message: '您还没有填写系统名称，请填写',
          trigger: 'blur'
        }],
        roleId: [{
          required: true,
          message: '您还没有填写角色编号，请填写',
          trigger: 'blur'
        }]
      },
      systems: [],
      rolePermissions: [],
      rolePermissionPagination: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      activeUserTabName: 'REGULAR',
      // true为新增，false为编辑
      isAddOrUpdate: true
    };
  },
  created: function created() {
    var _this$$route$query = this.$route.query,
      roleId = _this$$route$query.roleId,
      systemId = _this$$route$query.systemId;
    this.roleId = roleId;
    this.systemId = systemId;
    this.isAddOrUpdate = !this.roleId;
    this.getSystemData();
    if (!this.isAddOrUpdate) {
      this.showUserTab = true;
      this.getRoleInfo();
    }
  },
  methods: {
    handleUsersTabClick: function handleUsersTabClick(instance) {
      if (instance.name === 'DYNAMIC') {
        this.activeUserTabName = 'DYNAMIC';
      }
      if (instance.name === 'REGULAR') {
        this.activeUserTabName = 'REGULAR';
      }
    },
    /**
     * @description 编辑情况下，获取角色数据
     * @return {void}
     * @author 🦉Owllai🦉 2022/06/13
     */
    getRoleInfo: function getRoleInfo() {
      var _this = this;
      var pageNum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
      this.$API.getRequest({
        url: '/platform/roleInner/detail',
        data: {
          roleId: this.roleId,
          systemId: this.systemId
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          var _res$result = res.result,
            roleId = _res$result.roleId,
            systemId = _res$result.systemId,
            systemName = _res$result.systemName,
            roleName = _res$result.roleName,
            roleType = _res$result.roleType,
            roleStatus = _res$result.roleStatus,
            roleDescription = _res$result.roleDescription,
            canSetManageOrg = _res$result.canSetManageOrg,
            canSetBizLine = _res$result.canSetBizLine,
            autoComputeArea = _res$result.autoComputeArea,
            id = _res$result.id,
            userLabelRuleId = _res$result.userLabelRuleId,
            userLabelRuleName = _res$result.userLabelRuleName;
          _this.basicInfoFormData.roleId = roleId;
          _this.basicInfoFormData.roleName = roleName;
          _this.basicInfoFormData.systemId = systemId;
          _this.basicInfoFormData.systemName = systemName;
          _this.basicInfoFormData.roleType = roleType.key;
          _this.basicInfoFormData.roleStatus = roleStatus.key;
          _this.basicInfoFormData.roleDescription = roleDescription;
          _this.basicInfoFormData.canSetManageOrg = canSetManageOrg;
          _this.basicInfoFormData.canSetBizLine = canSetBizLine;
          _this.basicInfoFormData.autoComputeArea = autoComputeArea;
          _this.basicInfoFormData.id = id;
          _this.basicInfoFormData.userLabelRuleId = userLabelRuleId;
          _this.basicInfoFormData.userLabelRuleName = userLabelRuleName;
          _this.getRolePermissions(_this.systemId, pageNum, pageSize);
        }
      });
    },
    /**
     * @description 获取系统列表数据
     * @return {void}
     * @author 🦉Owllai🦉 2022/06/10
     */
    getSystemData: function getSystemData() {
      var _this2 = this;
      this.$API.getRequest({
        url: '/platform/systemInner/list'
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this2.systems = Array.isArray(res.result.records) && res.result.records;
        }
      });
    },
    /**
     * @description 获取角色权限列表数据
     * @param {String} systemId
     * @param {number} pageNum
     * @param {number} pageSize
     * @return {void}
     * @author 🦉Owllai🦉 2022/06/10
     */
    getRolePermissions: function getRolePermissions(systemId) {
      var _this3 = this;
      var pageNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
      this.tableLoading = true;
      this.$API.getRequest({
        url: "/platform/roleInner/permission/rolePermission/role/".concat(this.basicInfoFormData.roleId),
        data: {
          systemId: systemId,
          pageNum: pageNum,
          pageSize: pageSize
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this3.rolePermissions = Array.isArray(res.result.records) && res.result.records;
          if (_this3.isAddOrUpdate) {
            _this3.rolePermissions.forEach(function (item) {
              _this3.basicInfoFormData.rolePermissionRefDtoS.forEach(function (dto) {
                if (item.id === dto.id) {
                  item.isChosen = true;
                }
              });
            });
          } else {
            _this3.rolePermissions.forEach(function (item) {
              _this3.basicInfoFormData.rolePermissionRefDtoS.filter(function (row) {
                return item.id !== row.id;
              });
              if (item.isChosen) {
                _this3.basicInfoFormData.rolePermissionRefDtoS.push(item);
              }
            });
          }
          _this3.rolePermissionPagination.total = res.result.total;
        }
        _this3.tableLoading = false;
      });
    },
    /**
     * @description 如果是否开启条线选择为‘是’，要自动将“是否设定管辖部门”的值更新为“是”
     * @param {Number} event
     * @return {void}
     * @author 🦉Owllai🦉 2022/06/13
     */
    canSetBizLineSelectChange: function canSetBizLineSelectChange(event) {
      if (event === 1) {
        this.basicInfoFormData.canSetManageOrg = 1;
      }
    },
    /**
     * @description 提交表单
     * @param {Boolean} needAddUser 是否为角色添加用户
     * @return {void}
     * @author 🦉Owllai🦉 2022/06/09
     */
    submit: function submit(needAddUser) {
      var _this4 = this;
      this.$refs.basicForm.validate(function (valid) {
        if (valid) {
          _this4.basicInfoFormData.systemName = _this4.systems.filter(function (systemItem) {
            return systemItem.systemId === _this4.basicInfoFormData.systemId;
          }).systemName;
          _this4.$API.postRequest({
            url: '/platform/roleInner',
            data: _this4.basicInfoFormData
          }).then(function (res) {
            if (res.code === '0000000000') {
              _this4.$message.success('新增角色成功！');
              _this4.basicInfoFormData.id = res.result;
              if (needAddUser) {
                _this4.showUserTab = true;
                _this4.activeTabName = 'USERS';
                _this4.handleClickTab({
                  name: 'USERS'
                });
                _this4.isAddOrUpdate = false;
              } else {
                _this4.$router.push({
                  path: '/system/role'
                });
              }
            }
          });
        }
      });
    },
    // 编辑情况下，保存按钮点击事件
    save: function save() {
      var _this5 = this;
      this.$refs.basicForm.validate(function (valid) {
        if (valid) {
          _this5.basicInfoFormData.systemName = _this5.systems.filter(function (systemItem) {
            return systemItem.systemId === _this5.basicInfoFormData.systemId;
          }).systemName;
          _this5.$API.putRequest({
            url: '/platform/roleInner',
            data: _this5.basicInfoFormData
          }).then(function (res) {
            if (res.code === '0000000000') {
              _this5.$message.success('编辑角色成功！');
              _this5.systemId = _this5.basicInfoFormData.systemId;
              _this5.roleId = _this5.basicInfoFormData.roleId;
              _this5.getRoleInfo(_this5.rolePermissionPagination.pageNum, _this5.rolePermissionPagination.pageSize);
            }
          });
        }
      });
    },
    // 系统名称下拉框 触发事件
    systemSelectChange: function systemSelectChange(value) {
      if (!this.basicInfoFormData.roleId) {
        this.$message.error('请填写角色编号后再重新选择系统名称！');
        return;
      }
      this.rolePermissionPagination.total = 0;
      this.rolePermissionPagination.pageNum = 1;
      this.rolePermissionPagination.pageSize = 10;
      this.getRolePermissions(value, 1, 10);
    },
    // 角色权限table pageNum回调事件
    rolePermissionCurrentChange: function rolePermissionCurrentChange(value) {
      this.rolePermissionPagination.pageNum = value;
      this.getRolePermissions(this.basicInfoFormData.systemId, this.rolePermissionPagination.pageNum, this.rolePermissionPagination.pageSize);
    },
    // 角色权限table pageSize回调事件
    rolePermissionSizeChange: function rolePermissionSizeChange(value) {
      this.rolePermissionPagination.total = 0;
      this.rolePermissionPagination.pageNum = 1;
      this.rolePermissionPagination.pageSize = value;
      this.getRolePermissions(this.basicInfoFormData.systemId, this.rolePermissionPagination.pageNum, this.rolePermissionPagination.pageSize);
    },
    /**
     * @description 处理取消操作
     * @param {Boolean} flag true为确定取消
     * @author 🦉Owllai🦉 2022/06/09
     */
    confirmCancel: function confirmCancel(flag) {
      flag && this.$router.push({
        path: '/system/role'
      });
    },
    // '基本信息' | '用户列表' tab点击事件
    handleClickTab: function handleClickTab(tab) {
      if (tab.name === 'USERS') {
        this.handleUsersTabClick({
          name: 'REGULAR'
        });
      }
    },
    autoComputeAreaChange: function autoComputeAreaChange(value) {
      if (value === 0) {
        this.handleClickTab({
          name: 'USERS'
        });
      }
    },
    handleCheckboxChange: function handleCheckboxChange(event, row) {
      this.basicInfoFormData.rolePermissionRefDtoS = this.basicInfoFormData.rolePermissionRefDtoS.filter(function (item) {
        return item.id !== row.id;
      });
      this.basicInfoFormData.rolePermissionRefDtoS.push(row);
    }
  }
};